<mat-card class="information-fastlink-card">
  <mat-card-header>
    <div mat-card-avatar class="modbus-header-image">
      <mat-icon aria-hidden="false" aria-label="home icon">memory</mat-icon>
    </div>
    <mat-card-title>Fastlink information</mat-card-title>
  </mat-card-header>
  <mat-card-content>


    <hr/>
    <div *ngIf="information.flConfig_nrFieldStations > 0;">
      <div *ngIf="information.flStatus_code == 0;">
        <mat-icon mat-icon class="material-icons color_alert">warning</mat-icon>
        <p>Warning no fastlink found but needed</p>
      </div>
      <div *ngIf="information.flStatus_nrFieldStations != information.flConfig_nrFieldStations;">
        <mat-icon mat-icon class="material-icons color_alert">warning</mat-icon>
        <p> Warning number fastlink found and configured are different </p>
      </div>
    </div>
    <hr/>


    <div *ngIf="information.flConfig_code == 56; else elseBlockPresent">
      <!--        Fastlink has been initialized by config -->
      Fastlink :
      <ul>
        <li>is initialized.</li>
        <li>local fastlinks found: {{ information.flStatus_cards }} </li>
      </ul>


    </div>

    Fastlink Fieldstations: :
    <ul>
      <li>Fieldstations configured:  {{ information.flConfig_nrFieldStations }}  </li>
      <li>Fieldstations found:  {{ information.flStatus_nrFieldStations }}  </li>
      <li>Fastlinks found: {{ information.flStatus_nrFastlinks }}</li>
    </ul>

    Errorcodes:
    <ul>
      <div *ngIf="information.flStatus_errorcode >= 0; else elseBlockError">
        <li>Fieldstation:    {{ information.flStatus_fieldStationInErr }} in fault</li>
        <li>Error nr:  {{ information.flStatus_errorcode }} </li>
        <li> {{ information.flStatus_errorcodeStr }} </li>
      </div>
      <ng-template #elseBlockError>
        <li>No Errors</li>
      </ng-template>
    </ul>


    Signal:
    <ul>
      <li>Quality: {{ information.flStatus_pollQuality }}  %</li>
      <li> {{ information.signalquality }}</li>
      <li>Last update {{ information.flStatus_lastUpdate }} sec. ago</li>
    </ul>


    <ng-template #elseBlockPresent>
      <!--        Fastlink has NOT been initialized by config and is not needed -->
      Fastlink :
      <ul>
        <li>is NOT initialized.</li>
      </ul>
    </ng-template>

  </mat-card-content>
</mat-card>
